// extracted by mini-css-extract-plugin
module.exports = {"collections":"an","headingContainer":"bn","accountHeader":"cn","newCollection":"dn","disabled":"en","collectionListContainer":"fn","loadMore":"gn"};